var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-loader"},[_c('span',{staticClass:"card-loader__machine"}),_c('CreditCard',{class:{
      'creditcard--animated': _vm.isAnimated,
      'creditcard--endstate': _vm.isEndState || !_vm.animation,
    },attrs:{"card":_vm.card,"isFlipped":_vm.isFlipped}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }